// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-module_layout__oisxe {
    --cw-layout-flex-direction: column;
    --cw-layout-justify-content: flex-start;
    --cw-layout-align-items: center;
    --cw-layout-width: 100%;
    --cw-layout-min-width: auto;
    --cw-layout-height: auto;
    --cw-layout-min-height: auto;
    --cw-layout-bg: transparent;
    --cw-layout-bg-hover: transparent;
    --cw-layout-bg-pressed: var(--cw-layout-bg);
    --cw-layout-border-radius: 0px;
    --cw-layout-border-width: 0px;
    --cw-layout-border-color: transparent;
    --cw-layout-box-shadow: none;
    --cw-layout-box-shadow-hover: var(--cw-layout-box-shadow);
    --cw-layout-box-shadow-pressed: var(--cw-layout-box-shadow-hover);
    --cw-layout-overflow: visible;
    --cw-layout-margin-top: 0px;
    --cw-layout-margin-right: 0px;
    --cw-layout-margin-bottom: 0px;
    --cw-layout-margin-left: 0px;
    --cw-layout-padding-top: 0px;
    --cw-layout-padding-right: 0px;
    --cw-layout-padding-bottom: 0px;
    --cw-layout-padding-left: 0px;
    --cw-layout-gap: 0px;
    --cw-layout-flex-shrink: 1;
    --cw-layout-opacity: 1;

    display: flex;
    font: inherit;
    color: inherit;
    opacity: var(--cw-layout-opacity);
    flex-shrink: var(--cw-layout-flex-shrink);
    flex-direction: var(--cw-layout-flex-direction);
    justify-content: var(--cw-layout-justify-content);
    align-items: var(--cw-layout-align-items);
    width: calc(var(--cw-layout-width) - var(--cw-layout-margin-right) - var(--cw-layout-margin-left));
    min-width: var(--cw-layout-min-width);
    min-height: var(--cw-layout-min-height);
    height: var(--cw-layout-height);
    background: var(--cw-layout-bg);
    border-radius: var(--cw-layout-border-radius);
    border: var(--cw-layout-border-width) solid var(--cw-layout-border-color);
    box-shadow: var(--cw-layout-box-shadow);
    overflow: var(--cw-layout-overflow);
    box-sizing: border-box;
    margin: var(--cw-layout-margin-top) var(--cw-layout-margin-right) var(--cw-layout-margin-bottom) var(--cw-layout-margin-left);
    padding: var(--cw-layout-padding-top) var(--cw-layout-padding-right) var(--cw-layout-padding-bottom) var(--cw-layout-padding-left);
    gap: var(--cw-layout-gap);
}

.layout-module_clickable__EfQG6 {
    cursor: pointer;

    /* Touch browsers emulate a sticky :hover after a tap/long press — apply hover only for real pointers. */
    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background-color: var(--cw-layout-bg-hover);
            box-shadow: var(--cw-layout-box-shadow-hover);
        }
    }

    &:active {
        background: var(--cw-layout-bg-pressed);
        box-shadow: var(--cw-layout-box-shadow-pressed);
    }
}

.layout-module_disabled__x3Ria {
    cursor: default;
    pointer-events: none;
}

.layout-module_layout__oisxe.layout-module_fullWidth__dtRgN {
    width: var(--cw-layout-width);
}

.layout-module_layout__oisxe.layout-module_layoutBox__T639r {
    display: block;
    position: relative;
    width: var(--cw-layout-width);
}

.layout-module_layoutBoxInner__Gl695 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

/*
 * Applied only when \`backgroundImage\` resolves to a usable URL. Kept as a separate class
 * (instead of a \`--cw-layout-bg-image: none\` default) because \`--cw-layout-bg\` may itself
 * carry a url()/gradient — an unconditional \`background-image\` would reset it to \`none\`.
 * Declared last so the \`background\` shorthands in \`.clickable:active\` cannot drop the image.
 */
.layout-module_layout__oisxe.layout-module_backgroundImage__kimZW {
    background-image: var(--cw-layout-bg-image);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
`, "",{"version":3,"sources":["webpack://./../../packages/core-widgets/src/layout/layout.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;IAC/B,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,iCAAiC;IACjC,2CAA2C;IAC3C,8BAA8B;IAC9B,6BAA6B;IAC7B,qCAAqC;IACrC,4BAA4B;IAC5B,yDAAyD;IACzD,iEAAiE;IACjE,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;IAC7B,oBAAoB;IACpB,0BAA0B;IAC1B,sBAAsB;;IAEtB,aAAa;IACb,aAAa;IACb,cAAc;IACd,iCAAiC;IACjC,yCAAyC;IACzC,+CAA+C;IAC/C,iDAAiD;IACjD,yCAAyC;IACzC,kGAAkG;IAClG,qCAAqC;IACrC,uCAAuC;IACvC,+BAA+B;IAC/B,+BAA+B;IAC/B,6CAA6C;IAC7C,yEAAyE;IACzE,uCAAuC;IACvC,mCAAmC;IACnC,sBAAsB;IACtB,6HAA6H;IAC7H,kIAAkI;IAClI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;;IAEf,wGAAwG;IACxG;QACI;YACI,2CAA2C;YAC3C,6CAA6C;QACjD;IACJ;;IAEA;QACI,uCAAuC;QACvC,+CAA+C;IACnD;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;EAKE;AACF;IACI,2CAA2C;IAC3C,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B","sourcesContent":[".layout {\n    --cw-layout-flex-direction: column;\n    --cw-layout-justify-content: flex-start;\n    --cw-layout-align-items: center;\n    --cw-layout-width: 100%;\n    --cw-layout-min-width: auto;\n    --cw-layout-height: auto;\n    --cw-layout-min-height: auto;\n    --cw-layout-bg: transparent;\n    --cw-layout-bg-hover: transparent;\n    --cw-layout-bg-pressed: var(--cw-layout-bg);\n    --cw-layout-border-radius: 0px;\n    --cw-layout-border-width: 0px;\n    --cw-layout-border-color: transparent;\n    --cw-layout-box-shadow: none;\n    --cw-layout-box-shadow-hover: var(--cw-layout-box-shadow);\n    --cw-layout-box-shadow-pressed: var(--cw-layout-box-shadow-hover);\n    --cw-layout-overflow: visible;\n    --cw-layout-margin-top: 0px;\n    --cw-layout-margin-right: 0px;\n    --cw-layout-margin-bottom: 0px;\n    --cw-layout-margin-left: 0px;\n    --cw-layout-padding-top: 0px;\n    --cw-layout-padding-right: 0px;\n    --cw-layout-padding-bottom: 0px;\n    --cw-layout-padding-left: 0px;\n    --cw-layout-gap: 0px;\n    --cw-layout-flex-shrink: 1;\n    --cw-layout-opacity: 1;\n\n    display: flex;\n    font: inherit;\n    color: inherit;\n    opacity: var(--cw-layout-opacity);\n    flex-shrink: var(--cw-layout-flex-shrink);\n    flex-direction: var(--cw-layout-flex-direction);\n    justify-content: var(--cw-layout-justify-content);\n    align-items: var(--cw-layout-align-items);\n    width: calc(var(--cw-layout-width) - var(--cw-layout-margin-right) - var(--cw-layout-margin-left));\n    min-width: var(--cw-layout-min-width);\n    min-height: var(--cw-layout-min-height);\n    height: var(--cw-layout-height);\n    background: var(--cw-layout-bg);\n    border-radius: var(--cw-layout-border-radius);\n    border: var(--cw-layout-border-width) solid var(--cw-layout-border-color);\n    box-shadow: var(--cw-layout-box-shadow);\n    overflow: var(--cw-layout-overflow);\n    box-sizing: border-box;\n    margin: var(--cw-layout-margin-top) var(--cw-layout-margin-right) var(--cw-layout-margin-bottom) var(--cw-layout-margin-left);\n    padding: var(--cw-layout-padding-top) var(--cw-layout-padding-right) var(--cw-layout-padding-bottom) var(--cw-layout-padding-left);\n    gap: var(--cw-layout-gap);\n}\n\n.clickable {\n    cursor: pointer;\n\n    /* Touch browsers emulate a sticky :hover after a tap/long press — apply hover only for real pointers. */\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background-color: var(--cw-layout-bg-hover);\n            box-shadow: var(--cw-layout-box-shadow-hover);\n        }\n    }\n\n    &:active {\n        background: var(--cw-layout-bg-pressed);\n        box-shadow: var(--cw-layout-box-shadow-pressed);\n    }\n}\n\n.disabled {\n    cursor: default;\n    pointer-events: none;\n}\n\n.layout.fullWidth {\n    width: var(--cw-layout-width);\n}\n\n.layout.layoutBox {\n    display: block;\n    position: relative;\n    width: var(--cw-layout-width);\n}\n\n.layoutBoxInner {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n}\n\n/*\n * Applied only when `backgroundImage` resolves to a usable URL. Kept as a separate class\n * (instead of a `--cw-layout-bg-image: none` default) because `--cw-layout-bg` may itself\n * carry a url()/gradient — an unconditional `background-image` would reset it to `none`.\n * Declared last so the `background` shorthands in `.clickable:active` cannot drop the image.\n */\n.layout.backgroundImage {\n    background-image: var(--cw-layout-bg-image);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `layout-module_layout__oisxe`,
	"clickable": `layout-module_clickable__EfQG6`,
	"disabled": `layout-module_disabled__x3Ria`,
	"fullWidth": `layout-module_fullWidth__dtRgN`,
	"layoutBox": `layout-module_layoutBox__T639r`,
	"layoutBoxInner": `layout-module_layoutBoxInner__Gl695`,
	"backgroundImage": `layout-module_backgroundImage__kimZW`
};
export default ___CSS_LOADER_EXPORT___;
